import React from 'react';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import { user_token } from '../../../services/Auth';
import api from '../../../services/api'
import { withRouter } from 'react-router-dom';

//import da API
import { professional } from './../../../services/api';
let apiProfessional = new professional();

var boolt = true;
var boolf = false;

var token = localStorage.getItem(user_token);
class FormPM extends React.Component {

    //PATCH LOGIC
    constructor() {
        super();
        this.state = {
            status: "Realizada",
            medications_in_use: "",
            physical_activity: true,
            smoking: true,
            smoking_amount: "",
            alcoholism: true,
            alcoholism_amount: "",
            surgery: "",
            anamnese: "",
            referrals: "",
            medical_note: "",
            conduct: "",
            diagnosis: "",
            prescription: "",
            date: ""
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSubmit = evt => {
        evt.preventDefault();

        const prontuario = {
            status: this.state.status,
            date: new Date(),
            monitoration_record: {
                medications_in_use: this.state.medications_in_use,
                life_habits: {
                    physical_activity: this.state.physical_activity,
                    smoking: this.state.smoking,
                    smoking_amount: this.state.smoking_amount,
                    alcoholism: this.state.alcoholism,
                    alcoholism_amount: this.state.alcoholism_amount,
                    surgery: this.state.surgery,
                },
                anamnese: this.state.anamnese,
                referrals: this.state.referrals,
                conduct: this.state.conduct,
                diagnosis: this.state.diagnosis,
            },
            medical_note: this.state.medical_note,
            prescription: this.state.prescription,
        };
        console.log(prontuario)
        //ID está setada -> Necessário Correção
        //api.patch(`/exam/${this.props.exam_id}`, prontuario, {headers: {'x-access-token': token, 'op': "set"}} )
        apiProfessional.editExam(prontuario, this.props.exam_id, 'set')
            .then(res => {
                console.log(res);
                console.log(res.data);
                alert("Prescrição feita com sucesso!");
                this.props.history.push("/tela_ps_painel");
            })

    }

render() {
    return (
        <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
            <h1 id="tittle-forms-cme">Prontuário de Monitoração</h1>
            <p id="RI-Title-Cadastro" >Medicamentos em uso</p>
            <textarea onChange={this.handleChange} name="medications_in_use" placeholder="Medicamentos em uso" id="RI-Cadastro" />           
            <p type="ratio" id="RI-Title-Cadastro">Pratica atividade física regularmente?</p>
            <select id="Pront_Init" onChange={this.handleChange} name="physical_activity" required>
                <option></option>
                <option value={boolt}>Sim</option>
                <option value={boolf}>Não</option>
            </select>
            <p type="ratio" id="RI-Title-Cadastro">Tabagismo</p>
            <select id="Pront_Init" onChange={this.handleChange} name="smoking" required>
                <option></option>
                <option value={boolt}>Sim</option>
                <option value={boolf}>Não</option>
            </select>
            <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quantos cigarros o(a) paciente fuma por dia?</p>
            <input onChange={this.handleChange} name="smoking_amount" placeholder="Quantidade de cigarros por dia" id="RI-Cadastro" />
            <p type="ratio" id="RI-Title-Cadastro">Alcoolismo</p>
            <select id="Pront_Init" onChange={this.handleChange} name="alcoholism" required>
                <option></option>
                <option value={boolt}>Sim</option>
                <option value={boolf}>Não</option>
            </select>
            <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quantas doses o(a) paciente bebe por dia?</p>
            <input onChange={this.handleChange} name="alcoholism_amount" placeholder="Quantidade consumida por dia" id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Histórico de Cirurgias:</p>
            <textarea onChange={this.handleChange} name="surgery" placeholder="Histórico de Cirurgia" id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Anamnese:</p>
            <textarea onChange={this.handleChange} name="anamnese" placeholder="Campo de atualizações desde a primeira consulta: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Encaminhamentos:</p>
            <textarea onChange={this.handleChange} name="referrals" placeholder="Insira os encaminhamentos: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Conduta:</p>
            <textarea onChange={this.handleChange} name="conduct" placeholder="Insira a conduta: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Diagnóstico:</p>
            <textarea onChange={this.handleChange} name="diagnosis" placeholder="Insira o diagnóstico: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Observações:</p>
            <textarea onChange={this.handleChange} name="medical_note" placeholder="Insira observações: " id="RI-Cadastro" />
            <h1 id="tittle-forms-cme">Insira a prescrição para o paciente:</h1>
            <p id="RI-Title-Cadastro" >Este será o único campo que será visualizado pelo representante de instituição</p>
            <textarea onChange={this.handleChange} name="prescription" placeholder="(Essa informação será visualizada pelo paciente)" id="RI-Cadastro" />
            <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
            </div> 
        </form>
    );
}
}
export default withRouter(FormPM);
